import dayjs from 'dayjs'

// The Review page's playback survives leaving the page: it is saved when the page unmounts and
// restored when it is opened again (until the browser tab is reloaded).
let saved = null

export const saveReviewSession = ({ startDate, endDate, currentTime, isPlaying, playSpeed }) => {
  saved = { startDate, endDate, currentTime, isPlaying, playSpeed, savedAt: Date.now() }
}

// If it was playing, the timeline moves on by the time spent away (x speed), up to the end of the range
export const restoreReviewSession = () => {
  if (!saved) return null

  const { startDate, endDate, playSpeed, savedAt } = saved
  let { currentTime, isPlaying } = saved

  if (isPlaying) {
    const moved = dayjs(currentTime).add((Date.now() - savedAt) * playSpeed, 'ms')
    if (moved.isBefore(endDate)) {
      currentTime = moved
    } else {
      currentTime = dayjs(endDate)
      isPlaying = false
    }
  }

  return { startDate, endDate, currentTime, isPlaying, playSpeed }
}
